export enum SnippetAreaEnum {
    BODY = 'BODY',
    LEAD = 'LEAD',
    CONTEXTUAL = 'CONTEXTUAL'
}
